import React, { ReactNode } from "react";
import styled, { css } from "styled-components";
import { Avatar } from "@sonder/ui/source/styled/components/Avatar";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { colors } from "@sonder/ui/source/styled/theme";

const UserDetails = styled.div`
  align-items: flex-start;
  display: inline-flex;
  flex-direction: column;
  margin-left: 0.75rem;
  text-align: left;
  min-width: 10rem;
`;
const UserCardButton = styled(Button)`
  height: 3.2rem;

  &:active ${UserDetails} span {
    color: ${colors.white};
  }
  ${UserDetails} span {
    color: ${props => props.selected && colors.white};
  }
`;

const SharedUserDetailStyles = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;
const UserName = styled.span`
  color: ${colors.blue2};
  font-weight: bold;
  max-width: 11rem;
  ${SharedUserDetailStyles}
`;
const UserEmail = styled.div`
  ${SharedUserDetailStyles}
`;
const UserRole = styled(UserName)`
  color: ${colors.grayA};
  font-weight: normal;
  font-size: 0.9rem;
`;

interface UserMenuProps {
  className?: string;
  email?: string;
  name?: string;
  noBorder?: boolean;
  fullWidth?: boolean;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  imageUrl?: string | null;
  role?: string;
  selected?: boolean;
  onClick?(e: React.MouseEvent): void;
}
export const UserCard = ({
  className,
  email,
  name,
  fullWidth,
  noBorder,
  iconLeft,
  iconRight,
  imageUrl,
  role,
  selected,
  onClick,
}: UserMenuProps) => (
  <UserCardButton
    className={className}
    fullWidth={fullWidth}
    iconLeft={Boolean(iconLeft)}
    iconRight={Boolean(iconRight)}
    noBorder={noBorder}
    selected={selected}
    onClick={onClick}
  >
    {iconLeft}
    <Avatar imageUrl={imageUrl} name={name} />
    <UserDetails>
      <UserName>{name}</UserName>
      <UserRole>{role}</UserRole>
      {email && <UserEmail>{email}</UserEmail>}
    </UserDetails>
    {iconRight}
  </UserCardButton>
);
